// extracted by mini-css-extract-plugin
export default {"text":"XhJz0Q4hSq"};